/* ============================================================
 * Vehar logistiko — Über-uns "Izanami" Effekt-Engine (Phase 1)
 * ------------------------------------------------------------
 * Smooth-Scroll (Lenis) + GSAP/ScrollTrigger Choreografie
 * + Custom-Cursor + magnetische Buttons + Scroll-Reveals
 * + Maus-Parallax (Hero) + gepinnte Timeline.
 *
 * Progressive Enhancement:
 *  - Inhalt ist ohne JS voll sichtbar (CSS blendet Reveals nur
 *    aus, sobald <html> die Klasse .veh-iz-js trägt).
 *  - Faellt eine CDN-Lib aus oder ist prefers-reduced-motion
 *    aktiv, wird alles sofort sichtbar geschaltet (Safety).
 * ============================================================ */
(function () {
  'use strict';

  var root = document.documentElement;
  var scope = document.querySelector('[data-veh-iz]');
  if (!scope) return;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TOUCH = window.matchMedia && window.matchMedia('(hover: none)').matches;

  // Alles sofort sichtbar machen (Fallback, wenn Effekte nicht laufen)
  function revealAll() {
    root.classList.add('veh-iz-ready');
    var hidden = scope.querySelectorAll('[data-reveal], [data-split]');
    for (var i = 0; i < hidden.length; i++) {
      hidden[i].style.opacity = '1';
      hidden[i].style.transform = 'none';
      hidden[i].style.clipPath = 'none';
    }
  }

  // Safety-Netz: falls in 2.5s nichts initialisiert ist -> aufdecken
  var safety = setTimeout(revealAll, 2500);

  function boot() {
    var hasGSAP = !!(window.gsap);
    var hasST = hasGSAP && !!(window.ScrollTrigger);

    // Kein GSAP oder Reduced-Motion -> nur Inhalt zeigen, keine Effekte
    if (!hasGSAP || REDUCED) {
      clearTimeout(safety);
      revealAll();
      return;
    }

    clearTimeout(safety);
    root.classList.add('veh-iz-ready');

    var gsap = window.gsap;
    if (hasST) gsap.registerPlugin(window.ScrollTrigger);

    /* ---------- 1) Scrollen: NATIV (kein Lenis) ----------
       Bewusst natives Scrollen für maximale Navigations-Stabilität im Live-Umfeld.
       ScrollTrigger arbeitet direkt mit dem nativen Scroll. */

    /* ---------- 2) Zeilen-/Wort-Split für Headlines ---------- */
    scope.querySelectorAll('[data-split]').forEach(function (el) {
      var words = el.textContent.trim().split(/\s+/);
      el.textContent = '';
      el.classList.add('veh-iz-split');
      words.forEach(function (w) {
        var wrap = document.createElement('span');
        wrap.className = 'veh-iz-word';
        var inner = document.createElement('span');
        inner.className = 'veh-iz-word__in';
        inner.textContent = w;
        wrap.appendChild(inner);
        el.appendChild(wrap);
        el.appendChild(document.createTextNode(' '));
      });
      el.style.opacity = '1';
      var inners = el.querySelectorAll('.veh-iz-word__in');
      gsap.set(inners, { yPercent: 115 });
      gsap.to(inners, {
        yPercent: 0, duration: 0.9, ease: 'power4.out', stagger: 0.05,
        scrollTrigger: hasST ? { trigger: el, start: 'top 85%' } : undefined
      });
    });

    /* ---------- 3) Scroll-Reveals (Fade + Rise) ---------- */
    scope.querySelectorAll('[data-reveal]').forEach(function (el, i) {
      gsap.set(el, { opacity: 0, y: 40 });
      gsap.to(el, {
        opacity: 1, y: 0, duration: 1, ease: 'power3.out',
        delay: (parseFloat(el.getAttribute('data-reveal-delay')) || 0),
        scrollTrigger: hasST ? { trigger: el, start: 'top 88%' } : undefined
      });
    });

    /* ---------- 4) Bild-Parallax beim Scrollen ---------- */
    if (hasST) {
      scope.querySelectorAll('[data-scroll-img]').forEach(function (el) {
        var img = el.querySelector('img');
        if (!img) return;
        gsap.fromTo(img, { yPercent: -8, scale: 1.12 }, {
          yPercent: 8, scale: 1.12, ease: 'none',
          scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true }
        });
      });
    }

    /* ---------- 5) Gepinnte horizontale Timeline (Desktop) ---------- */
    if (hasST) {
      var track = scope.querySelector('[data-timeline-track]');
      var pin = scope.querySelector('[data-timeline-pin]');
      var getScroll = function () { return Math.max(0, track ? track.scrollWidth - pin.clientWidth : 0); };
      if (track && pin && window.matchMedia('(min-width: 1000px)').matches && getScroll() > 0) {
        gsap.to(track, {
          x: function () { return -getScroll(); },
          ease: 'none',
          scrollTrigger: {
            trigger: pin,
            start: 'top top',
            end: function () { return '+=' + getScroll(); },
            pin: true,
            scrub: 1,
            invalidateOnRefresh: true,
            anticipatePin: 1
          }
        });
      }
    }

    /* ---------- 6) Hero: Maus-Parallax der Ebenen ---------- */
    var hero = scope.querySelector('[data-hero]');
    if (hero && !TOUCH) {
      var layers = hero.querySelectorAll('[data-hero-layer]');
      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect();
        var mx = (e.clientX - r.left) / r.width - 0.5;
        var my = (e.clientY - r.top) / r.height - 0.5;
        layers.forEach(function (l) {
          var depth = parseFloat(l.getAttribute('data-hero-layer')) || 10;
          gsap.to(l, { x: mx * depth, y: my * depth, duration: 0.8, ease: 'power2.out' });
        });
      });
    }

    /* ---------- 7) Custom-Cursor + magnetische Elemente ---------- */
    if (!TOUCH) {
      var dot = document.createElement('div');
      dot.className = 'veh-iz-cursor';
      var ring = document.createElement('div');
      ring.className = 'veh-iz-cursor-ring';
      document.body.appendChild(dot);
      document.body.appendChild(ring);
      root.classList.add('veh-iz-has-cursor');

      var mouseX = window.innerWidth / 2, mouseY = window.innerHeight / 2;
      var ringX = mouseX, ringY = mouseY;
      window.addEventListener('mousemove', function (e) {
        mouseX = e.clientX; mouseY = e.clientY;
        gsap.set(dot, { x: mouseX, y: mouseY });
      });
      gsap.ticker.add(function () {
        ringX += (mouseX - ringX) * 0.15;
        ringY += (mouseY - ringY) * 0.15;
        gsap.set(ring, { x: ringX, y: ringY });
      });

      // Cursor waechst über interaktiven Elementen
      scope.querySelectorAll('a, button, [data-cursor]').forEach(function (el) {
        el.addEventListener('mouseenter', function () { root.classList.add('veh-iz-cursor-hover'); });
        el.addEventListener('mouseleave', function () { root.classList.remove('veh-iz-cursor-hover'); });
      });

      // Magnetische Buttons/Links
      scope.querySelectorAll('[data-magnetic]').forEach(function (el) {
        var strength = parseFloat(el.getAttribute('data-magnetic')) || 0.35;
        el.addEventListener('mousemove', function (e) {
          var r = el.getBoundingClientRect();
          var x = e.clientX - r.left - r.width / 2;
          var y = e.clientY - r.top - r.height / 2;
          gsap.to(el, { x: x * strength, y: y * strength, duration: 0.5, ease: 'power3.out' });
        });
        el.addEventListener('mouseleave', function () {
          gsap.to(el, { x: 0, y: 0, duration: 0.6, ease: 'elastic.out(1, 0.4)' });
        });
      });
    }

    if (hasST) window.ScrollTrigger.refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 60); });
  } else {
    setTimeout(boot, 60);
  }
})();
